import React from 'react';

import { Box } from '@rover/kibble/core';

export interface ContainerProps {
  children: React.ReactNode;
  height?: string;
}

const Container: React.FC<ContainerProps> = ({ children, height }) => {
  return (
    <Box height={height} maxHeight={height ?? '450px'} paddingX="1x" sx={{ overflowY: 'auto' }}>
      {children}
    </Box>
  );
};

export default Container;
